import { motion } from "framer-motion";

export interface BreakdownItem {
  label: string;
  amount: number;
  count: number;
  color?: string;
}

interface Props {
  items: BreakdownItem[];
  total: number;
}

function fmtMoney(n: number) {
  if (n >= 1000) return `$${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k`;
  return `$${n}`;
}

/**
 * Horizontal staggered fill bars showing how a total breaks down by layer.
 * Each bar fills left-to-right in sequence (150ms stagger).
 */
export default function LayerBreakdown({ items, total }: Props) {
  const max = Math.max(total, 1);
  return (
    <div className="space-y-2.5">
      {items.map((item, i) => {
        const pct = (item.amount / max) * 100;
        return (
          <div key={item.label} className="space-y-1">
            <div className="flex items-center justify-between text-xs">
              <span className="font-medium text-foreground">
                {item.label}
                <span className="text-muted-foreground font-normal ml-1.5">
                  · {item.count} {item.count === 1 ? "program" : "programs"}
                </span>
              </span>
              <span className="font-semibold text-foreground tabular-nums">
                {fmtMoney(item.amount)}
              </span>
            </div>
            <div className="h-2 rounded-full bg-muted overflow-hidden">
              <motion.div
                className="h-full rounded-full"
                style={{ backgroundColor: item.color || "hsl(var(--primary))" }}
                initial={{ width: 0 }}
                animate={{ width: `${pct}%` }}
                transition={{ duration: 0.7, delay: 0.3 + i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}